export default __webpack_public_path__ + "static/media/report-thumbnail.9e85ea7f.jpg";